/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './search-team-members';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "BulkRetrieveTeamMembersRequest": {
            "fields": {
              "teamMemberIds": {
                "type": "string",
                "id": 1,
                "rule": "repeated"
              },
              "scope": {
                "type": ".squareup.team_api.SearchTeamMembersFilter.TeamMemberScope",
                "id": 2,
                "rule": "optional"
              },
              "include": {
                "type": ".squareup.team_api.TeamMemberIncludes.Include",
                "id": 3,
                "rule": "repeated"
              },
              "fetchFields": {
                "type": ".squareup.team_api.TeamMemberFetchFieldScope.FetchField",
                "id": 4,
                "rule": "repeated"
              }
            }
          },
          "BulkRetrieveTeamMembersResponse": {
            "fields": {
              "responses": {
                "type": ".squareup.team_api.BulkRetrieveTeamMembersResponse.RetrieveResponsePerTeamMemberId",
                "id": 1,
                "keyType": "string"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 2,
                "rule": "repeated"
              },
              "includedResources": {
                "type": ".squareup.team_api.TeamMemberIncludedResources",
                "id": 3,
                "rule": "optional"
              }
            },
            "nested": {
              "RetrieveResponsePerTeamMemberId": {
                "fields": {
                  "teamMember": {
                    "type": ".squareup.team_api.TeamMember",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.BulkRetrieveTeamMembersRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.BulkRetrieveTeamMembersResponse && !$root.nested?.squareup?.nested?.team_api?.nested?.BulkRetrieveTeamMembersResponse?.nested?.RetrieveResponsePerTeamMemberId) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a response from a bulk retrieve request containing a list of `TeamMember` objects or error messages.
 * --
 *
 * SOURCE BulkRetrieveTeamMembersRequest @ squareup/team_api/endpoints/bulk-retrieve-team-members.proto at 24:1
 */
export const BulkRetrieveTeamMembersRequest = $root.lookupType('squareup.team_api.BulkRetrieveTeamMembersRequest');
fixType(BulkRetrieveTeamMembersRequest);
Builder.createAndAttachToType(BulkRetrieveTeamMembersRequest);
/**
 * SOURCE BulkRetrieveTeamMembersResponse @ squareup/team_api/endpoints/bulk-retrieve-team-members.proto at 46:1
 */
export const BulkRetrieveTeamMembersResponse = $root.lookupType('squareup.team_api.BulkRetrieveTeamMembersResponse');
fixType(BulkRetrieveTeamMembersResponse);
Builder.createAndAttachToType(BulkRetrieveTeamMembersResponse);
/**
 * SOURCE RetrieveResponsePerTeamMemberId @ squareup/team_api/endpoints/bulk-retrieve-team-members.proto at 63:3
 */
BulkRetrieveTeamMembersResponse.RetrieveResponsePerTeamMemberId = $root.lookupType('squareup.team_api.BulkRetrieveTeamMembersResponse.RetrieveResponsePerTeamMemberId');
fixType(BulkRetrieveTeamMembersResponse.RetrieveResponsePerTeamMemberId);
Builder.createAndAttachToType(BulkRetrieveTeamMembersResponse.RetrieveResponsePerTeamMemberId);